import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, HttpClientModule, HttpClient} from '@angular/common/http';
import {ServiceWorkerModule} from '@angular/service-worker';
import {SharedModule} from '@shared/shared.module';
import {LoaderComponent} from '@shared/components/loader/loader.component';
import {CoreModule} from '@core/core.module';
import {HttpRequestInterceptor} from '@core/interceptors/http-interceptor';
import {AuthInterceptor} from '@core/interceptors/auth-interceptor';
import {LoaderInterceptor} from '@core/interceptors/loader.interceptor';
import {environment} from '../environments/environment';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

const COMPONENTS = [
    AppComponent,
    LoaderComponent
];

const MODULES = [
    CoreModule,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: environment.production,
        registrationStrategy: 'registerWhenStable:30000'
    }),
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
        },
        defaultLanguage: 'de'
    })
];

@NgModule({
    declarations: [...COMPONENTS],
    imports: [...MODULES],
    providers: [
        {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true},
        {provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true}
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
